import React, {useCallback, useState} from 'react';
import {Button, Container, Col, Row} from 'reactstrap';
import {Link, animateScroll as scroll} from 'react-scroll';
import ABTest, {DebugMenu} from 'react-controlled-ab';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import classNames from 'classnames';
import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent';

export default function ModalExitSales(props) {
  const {isOpen, toggle} = useExitIntent(60000);

  return (
    <Modal className="modal-exit-intent modal-exit-intent-empowerment" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading">Before you go!</h4>
          <h5 className="mt-0">
            Are you eating the wrong foods <br className="d-none d-xl-block" />
            that zap your health?
          </h5>
          <p>
            Learn what to eat to slash your risk of cancer, heart disease, Type 2 diabetes, autoimmune conditions, and
            Alzheimer’s, as well as obesity.
          </p>
          <p>
            Join today and learn how to protect <br className="d-none d-xl-block" />
            your health with delicious food!
          </p>
          <Button
            className="btn-exit text-uppercase text-white text-h5"
            color="cta"
            onClick={toggle}
            block
            activeClass="active"
            spy={true}
            offset={-55}
            to="offer-cta-2"
            smooth={true}
            href="#"
            tag={Link}
          >
            Get the Plant-Powered Playbook for $100 off
          </Button>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div
            className="exit-modal-image"
            style={{backgroundImage: `url('${require('static/backgrounds/1344525151-exit.jpg')}')`}}
          />
        </Col>
      </Row>
    </Modal>
  );
}
